import dayjs from "dayjs";
import { apiClient } from "../api/AllApi";

const BASE = "/settings/exchange-rates";

export const EXCHANGE_RATES_UPDATED_EVENT = "iqprice:exchange-rates-updated";

export const dispatchExchangeRatesUpdated = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(EXCHANGE_RATES_UPDATED_EVENT));
  }
};

/**
 * Rows with effective_from (Y-m-d). Returns the newest row whose effective_from is <= asOf date.
 */
export const pickEffectiveExchangeRate = (rows, asOf) => {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  const asOfStr = dayjs(asOf ?? undefined).format("YYYY-MM-DD");
  const eligible = rows.filter((r) => r?.effective_from && String(r.effective_from) <= asOfStr);
  if (eligible.length === 0) return null;
  eligible.sort((a, b) => String(b.effective_from).localeCompare(String(a.effective_from)));
  return eligible[0];
};

export const fetchExchangeRates = async () => {
  const res = await apiClient.get(BASE);
  return Array.isArray(res.data) ? res.data : [];
};

export const createExchangeRate = async (payload) => {
  const res = await apiClient.post(BASE, payload);
  return res.data;
};

export const updateExchangeRate = async (id, payload) => {
  const res = await apiClient.put(`${BASE}/${id}`, payload);
  return res.data;
};

export const deleteExchangeRate = async (id) => {
  await apiClient.delete(`${BASE}/${id}`);
};
